<template>
    <div class="material-box">
       <div class="material-content">
            <div class="top">
                <FormBox />
            </div>
            <template v-if="fileConfigList.length">
                <div class="idea-box mr10">
                    <div class="left">
                        <Material/>
                    </div>
                    <div class="right">
                        <SelectMaterial/>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="material-content">
                    <p class="ml20">不支持素材上传</p>
                </div>
            </template>
       </div>
        <div class="btns">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @click="handleOnSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>
import Material from './material.vue'
import SelectMaterial from './selectMaterial.vue'
import util from '@/libs/utils'
import { FILE_TYPE } from './constant'
import { TaskStore } from '@/utils/run-task'
import getMediaInfo from '@/libs/media';
import axios from 'axios';
import API from '@/api/marketManage/vivoBatch';
import { getMaterialInfoApi, getSearchConfigApi , genVideoCoverImg} from '@/api'
import FormBox from './formBox/index.vue'
import _ from 'lodash'
import COS from '@/libs/cos/Huaweiads'
import { getPrimeNum} from '@/utils'
import {  observableMap } from './formBox/create.js'
import { tipModal } from '../index.js'
export default {
    props:[ 'cbs', 'appList', 'config', 'displayType', 'account', 'configOpt', 'defaultData', 'getMaterialNum', 'rule' ],
    components: { Material, SelectMaterial, FormBox },
    provide(){
        return {
            global: this
        }
    },
    data() { 
        const displayTypeList = observableMap(this.displayType, (item)=> ({...item,num: 0,}))
		const appNumList = observableMap(this.appList, (item)=> ({...item,num: 0,}));
        const defaultData = this.defaultData || {};
        return {
            displayTypeList,
            appNumList,
            fileConfigList: [],
            coverConfigList: [],
            appId: '',
            searchConfigData: {
                material_status_map: [],
                plat_map: [],
            },
            selectList: defaultData,
            uploadStore: new TaskStore(10),//文件上传
            addMaterialStore: new TaskStore(10),//添加素材
            uploadFileListCancelData: {},//取消上传文件
            currentKey: '',//当前表单key
            errFileList:[],//错误文件列表
        }
    },
    computed: {
       
    },
    created() {
        this.getWorkOrderSearchConfig();
        this.uploadStore.on('end', ()=> {
            this.showValidateFileErrorData();
        });
    },
    methods: {
        formDataChange(acients, formData) {
            const key = acients.map(v=>v.payload.value).join('_');
            const oldKey = this.currentKey;
			// 防止重复渲染
			if(this.currentKey === key ) {
				return;
			}
			this.currentKey = key;
            this.updateFormOptionData()
            this.getMaterialInfo(formData, { key,  oldKey})
            console.log(key, 'keykeykey');
        },
        async getMaterialInfo(query, { key, oldKey }) {
            const params = {
                plat_id: 10,
                ...query,
            }
            const { data } = await getMaterialInfoApi(params);
            const oldFileConfigList = this.fileConfigList;
            this.fileConfigList = data.map((item)=> {
                const size = item.min_resolution && item.max_resolution?  `${item.min_resolution}px≤尺寸≤${item.max_resolution}px；` : ``;
                const [ min, max ] = (item.conf_length || '').split('-');
                const duration = item.creative_size_element_name === FILE_TYPE.VIEDO? `${min}s~${max}s;` : '';
                return {
                    ...item,
                    type: item.creative_size_element_name,
                    id: _.uniqueId(),
                    format_text: `${item.creative_size_element_title}: 宽高比(${item.resolution_ratio})，${size}${duration} 大小≤${item.file_size_kb_limit}`
                }
            });
            console.log(this.fileConfigList, 'this.fileConfigListthis.fileConfigList');
            if(!this.fileConfigList.length) {
                this.selectList[key] = [ null ];
                this.updateFormOptionData()
                return;
            }
            this.$nextTick(()=> {
                this.$bus.$emit('updateListData');
                const [ old_app_id ] = oldKey.split('_');
                const [ app_id ] = key.split('_');
                if(app_id !== old_app_id || !oldFileConfigList.length) {
                    const data = this.appList.find(v=>v.value == app_id);
                    this.$bus.$emit('updataFormNameData', data?.app_name);
                }
             })
        },
         // 验证文件
         async validateFile(file, configList) {
            const media  = await getMediaInfo(file);
            const ext = file.name.slice(file.name.lastIndexOf('.') + 1);
            
            const formatData = configList.reduce((pre, item)=> {
                pre.size.push(item.conf_size);
                if(item.min_resolution && item.max_resolution) {
                    const [ minW, minH] = item.min_resolution.split('*');
                    const [ maxW, maxH] = item.max_resolution.split('*');
                    pre.wh.push([ [ minW, minH ], [ maxW, maxH ] ]);
                    const [ w, h ] = item.resolution_ratio.split(':');
                    pre.ratio.push(_.floor(w / h, 2));
                }else {
                    pre.wh.push([[ item.width , item.height ]]);	
                    pre.ratio.push(_.floor(item.width / item.height, 2));
                };
                if(item.conf_length) {
                    const [ min, max ] = item.conf_length.split('-');
                    pre.duration.push([ min, max ]);
                }
                pre.format.add(item.file_format)
                return pre;
            }, { size: [], wh: [], format: new Set(), ratio: [], duration: [] });
           
            const { duration, fileSize, height, width , format } = media;
            if (![...formatData.format].some(v=>v.indexOf(ext) >-1 )) {
                return Promise.reject({
                    name: file.name,
                    message: '素材格式不符合'
                });
            }
            // 验证大小
            if (!formatData.size.some(v=>fileSize < +v)) {
                return Promise.reject({
                    name: file.name,
                    message: '素材大小不符合'
                });
            }
            if( format === 'MPEG-4' && !formatData.duration.some(([ min, max ])=> {
                   return duration >= +min && duration <= +max
                })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材时长不符合'
                });
            }
            if (!formatData.wh.some((wh)=>{
                if(wh.length === 1) {
                    // const [ w, h] = wh[0];
                    // return height === +h && width === +w;;
                    // 图片不验证宽高  
                    return true;
                }else {
                    const [ [ minW, minH ], [ maxW, maxH ] ] = wh;
                    return height >= +minH && height <= +maxH && width >= +minW && width <= +maxW;
                }
            })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材尺寸不符合'
                });
            };
            // const [ cw, ch ] = getPrimeNum(width, height)
            if (!formatData.ratio.some(v=>{
                return  v === _.floor(width / height, 2)
            })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材宽高比不符合'
                });
            };
            // 统一验证
            const targetConfig = configList.find(item=> {
                const [ w, h] = [ item.width, item.height ];
                const { max_resolution, min_resolution} = item;
                const [ cw, ch ] = item.resolution_ratio.split(':');
                return (
                    fileSize < +item.conf_size &&
                    ( _.floor(cw / ch, 2) === _.floor(width / height, 2)) &&
                    (item.file_format.indexOf(ext) >-1)&&
                    ( !item.conf_length || ( item.conf_length && ( duration >= +item.conf_length.split('-')[0] && duration <= +item.conf_length.split('-')[1] ) ) )&&
                    ( max_resolution&& min_resolution ? ( height >= +min_resolution.split('*')[1] && height <= +max_resolution.split('*')[1] && width >= +min_resolution.split('*')[0] && width <= +max_resolution.split('*')[0] ) : true ) 
                );
            })
            if (!targetConfig) {
                return Promise.reject({
                    name: file.name,
                    message: '素材规格不符合'
                });
            }
            return { height, width, targetConfig } 
        },
         // 停止上传
         cancelUploadFile(key) {
            Object.values(this.uploadFileListCancelData).forEach(list=> {
                list.map(v=>v&&v())
            });
            this.uploadStore.stopAllTask()
        },
        // 提示验证失败的文件
        showValidateFileErrorData() {
            if (!this.errFileList.length) {
                return
            }
            const message = this.errFileList.map(v=> {
                return `<p>${v.name}</p><span>${v.message}</span>`
            })
            this.$notify.error({
                title: '错误',
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: `<div style="overflow-y: auto;max-height: 500px">${message.join('')}</div>`
            });
            this.errFileList = [];
        },
        async handleSelectData(check , data) {
            if (Array.isArray(data)) {
                data.forEach(item=> {
                    this.addMaterialStore.add(()=> this.handleSelectData(check, item))
                })
            }else {
                const coverId =  data.id;
                data.id = util.randomString(20);
                const dataList = this.selectList[data.key] || [];
                const type = data.config.type;
                if (check) {
                    if(type === FILE_TYPE.COVER &&  (coverId  || data.config.id)) {
                        // 自动生成
                       if(coverId) {
                        const findData = _.find(dataList, item=> item.id === coverId);
                        this.$set(findData, type, data);
                       }else {
                            const findData = _.find(dataList, item=> item[FILE_TYPE.VIEDO].config.id === data.config.id && !item[FILE_TYPE.COVER]);
                            if(findData) {
                                this.$set(findData, type, data);
                            }else {
                                console.log('没有可添加封面的视频');
                            }
                       }
                    }else {
                        const findData = _.find(dataList, item=> !item[type]);
                        if(findData) {
                            this.$set(findData, type, data)
                        }else {
                            dataList.push({
                                [type]: data,
                                id: util.randomString(20)
                            })
                        };
                    }
                   
                }else {
                    const findData = _.find(dataList, item=> data.id === item[type]?.id);
                    // 排除要删除的字段 和固定字段 后 判断是否需要保留当前数据
                    const length  = (_.keys(_.omit(findData, [
                        'id', 
                        type,
                        type ===FILE_TYPE.VIEDO? FILE_TYPE.COVER : ''
                    ]))).filter(v=>findData[v]).length;
                    if (length) {
                        this.$set(findData, type, null);
                        if(type ===FILE_TYPE.VIEDO ) {
                            this.$set(findData, FILE_TYPE.COVER, null);
                        }
                    }else {
                        const index = dataList.indexOf(findData);
                        if (index!== -1) {
                            dataList.splice(index, 1);
                        };
                    }
                }
                this.$set(this.selectList, data.key, dataList)
                this.updateFormOptionData();
                console.log(this.selectList, 'this.selectListthis.selectListthis.selectList');
                // 更新封面配置
                if(data.key === this.currentKey) {
                    this.setCoverConfigList(data.key)
                }
            };
        },
        setCoverConfigList(key) {
            const dataList = this.selectList[key] || [];
            const configList = dataList.filter(v=>!v[FILE_TYPE.COVER] && v[FILE_TYPE.VIEDO]).map(item=> {
                const data = item[FILE_TYPE.VIEDO];
                const { width, height } = data;
                    const config = {
                        file_format: "jpg/jpeg/png",
                        conf_size: "512000.00",
                        width: String(width),
                        height: String(height),
                        resolution_ratio: data.config.resolution_ratio,
                        file_size_kb_limit: "500KB",
                        creative_size_element_name: FILE_TYPE.COVER,
                        creative_size_element_title: "封面",
                        id: data.config.id,
                        type: FILE_TYPE.COVER,
                    };
                    const size =  `尺寸=${width}*${height}px`;
                    const format_text = `${config.creative_size_element_title}: 宽高比(${config.resolution_ratio})，大小≤${config.file_size_kb_limit}`;
                    config.format_text = format_text;
            		return config;
            });
            // 去重
            this.coverConfigList = _.uniqWith(configList, _.isEqual);
        },
        delAllCurAppData() {
            this.selectList[this.currentKey] = [];
        },
        handleUploadFile(file, param) {
            const task = async ()=> {
                let cancel = null;
                
                try {
                    
                    const { targetConfig, width, height } = await this.validateFile(file, param.configList).catch((error)=> {
                        console.log(error, '文件验证出错');
                        
                        this.errFileList.push(error);
                        return false
                    });
                    const fileConfig = targetConfig;
                    if (!fileConfig) {
                        return
                    }
                    const result = await COS.putObject(file, {
                        onTaskReady: (id)=> {
                            let list = this.uploadFileListCancelData[file.key];
                            if (!list) {
                                list = this.uploadFileListCancelData[file.key] = []
                            }
                            list.push(cancel = id);
                        },

                    });
                    if(FILE_TYPE.VIEDO === fileConfig.type) {
                        const params = {
                            video_url: result.path,
                            plat_id: '3',//固定传
                        }
                        const { data } = await genVideoCoverImg(params);
                        this.handleSelectData(true, {
                            ...result, key: file.key,config: fileConfig,
                            material_url: result.path, material_name: result.name,
                            full_material_url: result.full_path,
                            img_full_material_url: data.fullFilePath,
                            img_material_url: data.filePath,
                            width, height
                        })
                    }else {
                        this.handleSelectData(true, {
                            ...result, key: file.key,config: fileConfig,
                            material_url: result.path, material_name: result.name,
                            full_material_url: result.full_path,
                            img_full_material_url: result.full_path
                        })
                    }
                    
                    // this.handleSelectData(true, {
                    //     ...result, key: file.key,config: fileConfig,
                    //     material_url: result.path, material_name: result.name,
                    //     full_material_url: result.full_path,
                    //     img_full_material_url: result.full_path
                    // })
                } catch (error) {
                    console.log(error, '上传出错');
                    this.$message.error(error.info)
                }finally {
                    const list = this.uploadFileListCancelData[file.key] || []
                    const index = list.indexOf(cancel);
                    if (index !== -1) {
                        list.splice(index, 1);
                    };
                }
            };
            this.uploadStore.add(task);
        },
        async getWorkOrderSearchConfig() {
            const { data } = await getSearchConfigApi();
            this.searchConfigData = data;
        },
        async validateFn() {
            /**
             * empty  版位素材为空
             * required. 存在必填的素材
             */
            const errorDataList = { empty: [], required: [] }; 
            this.appList.forEach((item)=> {
                this.displayType.forEach((item2)=> {
                    const key = `${item.value}_${item2.value}`;
                    const list = this.selectList[key] || [];
                    if (list.includes(null)) {
                        return
                    }
                    if(!list.length) {
                        errorDataList.empty.push(`${item.app_name} - ${item2.label}`);
                        return;
                    }
                    const hasData = list.some((item)=> {
                        return item[FILE_TYPE.IMAGE] || item[FILE_TYPE.VIEDO]
                    });
                    if(!hasData) {
                        errorDataList.required.push(`${item.app_name} - ${item2.label}`)
                    };
                    const hasCover = list.every((item)=> {
                        return item[FILE_TYPE.VIEDO] ? !!item[FILE_TYPE.COVER] : true;
                    });
                    if(!hasCover) {
                        errorDataList.required.push(`${item.app_name} - ${item2.label}`)
                    }
                })
            });
            if(errorDataList.empty.length || errorDataList.required.length) {
                return Promise.reject(errorDataList);
            }else {
                return true;
            }
        },
        async handleOnSubmit() {
            try {
                await this.validateFn();
                this.cbs.onSubmit(this.selectList);
            } catch (error) {
                console.log(error, 'error');
                
                const { empty, required } = error;
                const tipData = {}
                if(empty.length) {
                	tipData['存在为空的素材']=empty
                };
                if(required.length) {
                	tipData['存在必填的素材']=required
                };
                tipModal({
                    props: {
                        tip: '',
                        list: tipData
                    },
                })
            }
        },
        // 更新表单选项数据
        updateFormOptionData() {
            const [ app_id ] = this.currentKey.split('_');
            const keys = Object.keys(this.selectList);
            this.displayTypeList.map(v=>{
                v.num = this.getMaterialNum(this.selectList[`${app_id}_${v.value}`], this.rule)
            })
            this.appNumList.map(v=>{
                const total = keys.reduce((pre, item)=> {
                    const [ app_id ] = item.split('_');
                    if(v.value == app_id) {
                        pre += this.getMaterialNum(this.selectList[item], this.rule);
                    }
                    return pre;
                }, 0);
                v.num = total;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.material-box {
    height: 100%;
    
    display: flex;
    flex-direction: column;
}
.material-content {
    flex: 1;
    overflow: auto;
}
.btns {
    padding: 20px 80px 20px 0;
    text-align: right;
    border-top: 1px solid #E4E7ED;
}
.idea-box {
    position: relative;
    border: 1px solid #E4E7ED;
    display: flex;
    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 38px;
        border: 2px solid #E4E7ED;
    }
   
    .left {
        flex: 1;
    }
    .right {
        width: 500px;
    }
}
</style>